import HttpClient from '@/utility/http-client';
import * as firebase from 'firebase';
import { APP_CONFIG } from '@/config/app-config';

export default {
    exchangeRate() {
        return HttpClient.instance().get(`/api/exchange_rate/`);
    },
    configuration() {
        return HttpClient.instance().get(`/api/configuration/1`);
    },
    feeBuyPro() {
        return HttpClient.instance().get(`/api/feebuypro/`);
    },

    getCustomerLevels() {
        return HttpClient.instance().get(`/api/customer_levels/`);
    },

    getWarehouse() {
        return HttpClient.instance().get(`/api/stores/`);
    },

    getChinaStore() {
        return HttpClient.instance().get(`/api/chinaStores/`);
    },
    
    getFeeGuarantee() {
        return HttpClient.instance().get(`/api/feeguarantee/`);
    },

    getDetailChinaStore(id) {
        return HttpClient.instance().get(`/api/chinaStores/${id}`);
    },

    getNotification(page: number, rowPerPage: number, filters: any[], bell: boolean) {
        const filter = filters && filters.length > 0 ? Buffer.from(JSON.stringify({ filter: filters })).toString('base64') : '';
        const url = `/api/notifications/?page=${page}&rowsPerPage=${rowPerPage}&filter=${filter}&bell=${bell}`;
        return HttpClient.instance().get(url);
    },

    updateStatusNotification(notifyId: number, dataRequest: any) {
        const url = `/api/notifications/${notifyId}`;
        return HttpClient.instance().post(url, dataRequest);
    },

    // uploadFile(file, name) {
    //     const storageRef=firebase.storage().ref(`${APP_CONFIG.settings.firebase_prefix}/complain/${name}`).put(file);
    //     storageRef.on(`state_changed`, 
    //         () => {
    //             storageRef.snapshot.ref.getDownloadURL().then((url) => {
    //                 return url;
    //             });
    //         }
    //     );
    // }

    uploadFile(data: FormData) {
        const http = HttpClient.instance();
        http.interceptors.request.use(
            (requestConfig) => {
                requestConfig.headers['Content-Type'] = 'multipart/form-data';
                return requestConfig;
            }
        );

        return http.post(`/api/complain/uploadfile/`, data);
    }
};
